import { useDispatch } from "react-redux";
import { openMenu } from '../../store/generalSlice';

function Header() {
    const dispatch = useDispatch()

    const menuClick = () => {
        dispatch(openMenu());
    }

    return <div className="mafia-header">
        <button className="open-menu-button" onClick={menuClick}>Menu</button>
        <div className="mafia-logo">Mafia 2.0</div>
    </div>
}

export default Header;